/*
 * @Descripttion: 
 * @version: 1.0
 * @Author: hayuu
 * @Date: 2024-09-09 09:54:38
 * @LastEditors: hayuu
 * @LastEditTime: 2025-04-01 16:45:49
 */
import Cookies from 'js-cookie'
import store from '@/store';

const TokenKey = 'Admin-Token'
const currentUserKey = 'userInfo'
const ExpiresInKey = 'Admin-Expires-In'

export function getToken() {
  let TokenKey = 'Admin-Token'
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function getExpiresIn() {
  return Cookies.get(ExpiresInKey) || -1
}

export function setExpiresIn(time) {
  return Cookies.set(ExpiresInKey, time)
}

export function removeExpiresIn() {
  return Cookies.remove(ExpiresInKey)
}

export function setCurrentUser(currentUser) {
  return localStorage.setItem(currentUserKey, JSON.stringify(currentUser));
  // return Cookies.set(currentUserKey, currentUser)
}

export function getCurrentUser() {
  return JSON.parse(localStorage.getItem(currentUserKey));
  // return Cookies.get(currentUserKey)
}
export function removeCurrentUser() {
  return localStorage.removeItem(currentUserKey);
  // return Cookies.get(currentUserKey)
}

export function isLogin(url) {
  if (!getToken()) {
    if (url) {
      localStorage.setItem("goUrl", url)
    }
    store.loginShow = true
    return false
  } else {
    return true
  }
}
